<template>
    <v-app id="inspire" :class="hideRightSide||hideLeftSide? 'whiteBackgroundWhenSmall': ''">
        <v-content>
            <v-container grid-list-xs fluid justify-center align-center class="my-auto outer-container">
                <v-layout row wrap style="width: 100%;">
                    <v-flex pa-4 :d-none="hideLeftSide" class="leftSideClass">
                        <UscrOrganizationSignUp v-if="isUSCR" @submitting="val => submittingLeft = val"/>
                        <VacrInstructorSignUp v-else
                            @cancel="submittingLeft = false"
                            @completed="completedLeft = true"
                            @submitting="val => submittingLeft=val" />
                    </v-flex>
                    <v-flex pa-4 class="rightSideClass" :d-none="hideRightSide" :class="hideLeftSide? 'whiteBackground': ''">
                        <template v-if="isUSCR">
                            <UscrInstructorSignUp
                                @cancel="submittingRight = false"
                                @completed="completedRight = true"
                                @submitting="val => submittingRight=val"
                                />
                            <v-divider class="mt-2 mb-4" v-if="submittingRight === false"/>
                        </template>
                        <StudentRegistration v-if="submittingRight === false"/>
                    </v-flex>
                </v-layout>
            </v-container>
            <error-dialog v-if="showErrorDialog" :error="error" @cancel="toggleShowErrorDialog" @confirm="toggleShowErrorDialog"/>
        </v-content>
    </v-app>
</template>


<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import Config from "../../config";
import UscrOrganizationSignUp from './uscr/UscrOrganizationSignUp.vue';
import StudentRegistration from './vacr/StudentRegistration.vue';
import UscrInstructorSignUp from './uscr/UscrInstructorSignUp.vue';
import VacrInstructorSignUp from './vacr/VacrInstructorSignUp.vue';
import ErrorDialog from "@utils/ErrorDialog.vue";
import TitleStrings from "@/entities/strings/definitions/signupStrings";
import { Watch } from "vue-property-decorator";
import { useErrorStore } from "@/stores/errorStore";
import { storeToRefs } from "pinia";

@Component({
    components: { StudentRegistration, UscrOrganizationSignUp, UscrInstructorSignUp, VacrInstructorSignUp, ErrorDialog },
    metaInfo() {
        return { title: `${TitleStrings.en.TITLE_SIGNUP} | ${Config.APP_TITLE}` };
    }
})
export default class AccountRequest extends Vue {
    submittingLeft: boolean = false;
    submittingRight: boolean = false;
    completedLeft: boolean = false;
    completedRight: boolean = false;
    // TODO: Change to composition api
    error = storeToRefs(useErrorStore()).errorMessage;
    // END TODO
    showErrorDialog: boolean = false;

    @Watch("error")
    onErrorChanged(val: string, oldVal: string) {
        if (val !== undefined) {
            this.showErrorDialog = true;
        }
    }

    toggleShowErrorDialog() {
        this.showErrorDialog = !this.showErrorDialog;
    }

    get isUSCR(): boolean {
        return Config.BASE_DOMAIN === 'USCR';
    }

    get hideLeftSide(): boolean {
        return this.submittingRight || this.completedRight;
    }

    get hideRightSide(): boolean {
        return this.submittingLeft || this.completedLeft;
    }
}
</script>

<style scoped>
#inspire {
    background-color: #f2f1ec;
}
.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}

.rightSideClass {
    background-color: #d7d7d7;
    width: 40%;
    display: flex;
    flex-direction: column;
}

.leftSideClass {
    width: 60%;
    background-color: white;
}

.leftSideClass > div {
    min-height: 400px;
}

.whiteBackground {
    background-color: white !important;
}

@media (max-width: 599px) {
    .outer-container {
        max-width: 100%;
        padding-left: 0px;
        padding-right: 0px;
    }
    .whiteBackgroundWhenSmall {
        background-color: white !important; 
    }
}
@media (min-width: 600px) {
    .outer-container {
        max-width: 80%;
    }
}
</style>
